import { useEffect, useState } from 'react';

export function useImageLoader({
  url,
  onLoad,
}: {
  url: string | undefined | null;
  onLoad?: () => void;
}) {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (url) {
      setImageLoaded(false);
      const img = new Image();
      img.src = url;
      img.onload = () => {
        setImageLoaded(true);
        onLoad?.();
      };
    }
  }, [url, onLoad]);

  return { imageLoaded, url };
}
